module.exports = __webpack_public_path__ + "html/info-app-sumo_e7389d67d8d687d427f604be76e0a338.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/info-app-sumo.html
// module id = AMWW
// module chunks = 3